import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section
      className="relative w-full min-h-screen flex items-center overflow-hidden"
      style={{
        backgroundImage:
          'url(https://public.readdy.ai/ai/img_res/466f1b9247e5385523f75bf1af912095.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center 30%',
      }}
    >
      {/* Layered gradient overlays for cinematic depth */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/95 via-[#0A0A0A]/78 to-[#0A0A0A]/15" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/80 via-transparent to-[#0A0A0A]/35" />

      {/* Vertical gold accent strip */}
      <div className="absolute left-0 top-0 h-full w-0.5 bg-gradient-to-b from-transparent via-[#C9A030]/50 to-transparent hidden lg:block" />

      {/* Content */}
      <div className="relative z-10 w-full px-6 lg:px-14 pt-28 pb-20">
        <div className="max-w-[720px]">

          {/* Platform badge */}
          <div className="flex items-center gap-4 mb-10">
            <div className="w-10 h-px bg-[#C9A030]" />
            <p className="text-[#C9A030] text-[10px] tracking-[0.45em] uppercase font-semibold">
              ISNetworld® &middot; Veriforce &middot; Avetta Specialists
            </p>
          </div>

          {/* Headline */}
          <h1 className="font-serif leading-[1.0] tracking-tight mb-8">
            <span className="block text-[56px] lg:text-[88px] font-light text-[#F2EDE3]">
              Your Compliance
            </span>
            <span className="block text-[56px] lg:text-[88px] font-light text-[#C9A030] italic">
              Guaranteed.
            </span>
          </h1>

          {/* Subtext */}
          <p className="text-[#F2EDE3]/55 text-[17px] font-light leading-relaxed mb-4 max-w-[500px]">
            <strong className="text-[#F2EDE3]/85 font-medium">Energy Contractor Services</strong> manages your ISNetworld®, Veriforce, and Avetta accounts — so you never lose a contract opportunity.
          </p>

          {/* Proof line */}
          <div className="flex items-center gap-3 mb-11">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shield-check-fill text-[#C9A030] text-base" />
            </div>
            <p className="text-[#F2EDE3]/40 text-[11px] tracking-[0.22em] uppercase font-light">
              100% approval guaranteed &middot; No contracts required &middot; Month-to-month
            </p>
          </div>

          {/* CTAs */}
          <div className="flex flex-wrap gap-3 mb-16">
            <Link
              to="/contact"
              className="bg-[#C9A030] text-[#0A0A0A] px-9 py-4 text-[11px] font-bold tracking-[0.25em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-[#D4B045]"
            >
              Get Compliant Today
            </Link>
            <a
              href="tel:4054081117"
              className="border border-[#F2EDE3]/22 text-[#F2EDE3]/70 px-8 py-4 text-[11px] font-medium tracking-[0.22em] uppercase whitespace-nowrap cursor-pointer transition-all duration-200 hover:border-[#C9A030]/60 hover:text-[#C9A030] flex items-center gap-2"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-xs" />
              </span>
              405-408-1117
            </a>
            <Link
              to="/services"
              className="text-[#F2EDE3]/38 px-4 py-4 text-[11px] font-medium tracking-[0.2em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:text-[#F2EDE3]/70 underline-offset-2 hover:underline"
            >
              View Services
            </Link>
          </div>

          {/* Platform logos */}
          <div>
            <p className="text-[#F2EDE3]/20 text-[10px] tracking-[0.3em] uppercase mb-5">Platforms We Manage</p>
            <div className="flex flex-wrap items-center gap-8">
              <img
                src="https://www.energycontractorservices.com/wp-content/uploads/2013/04/Screen-shot-2013-05-30-at-10.38.08-AM.png"
                alt="ISNetworld"
                className="h-8 w-auto object-contain opacity-40 hover:opacity-75 transition-opacity cursor-pointer"
              />
              <img
                src="https://www.energycontractorservices.com/wp-content/uploads/2024/06/veri-2.png"
                alt="Veriforce"
                className="h-9 w-auto object-contain opacity-40 hover:opacity-75 transition-opacity cursor-pointer"
              />
              <img
                src="https://www.energycontractorservices.com/wp-content/uploads/2012/06/avetta-logo-white-768x265-300x104.png"
                alt="Avetta"
                className="h-7 w-auto object-contain opacity-40 hover:opacity-75 transition-opacity cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Floating info box — bottom right */}
      <div className="absolute bottom-10 right-12 hidden xl:block">
        <div className="bg-[#0A0A0A]/80 border border-[#C9A030]/20 backdrop-blur-sm px-6 py-5 max-w-[220px]">
          <div className="w-6 h-0.5 bg-[#C9A030] mb-3" />
          <p className="font-serif text-[#F2EDE3] text-base font-light leading-snug mb-2">
            One call. One expert. One guaranteed outcome.
          </p>
          <p className="text-[#9A9A9A] text-[10px] tracking-wide font-light">
            Energy Contractor Services &mdash; Oklahoma City, OK
          </p>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-14 hidden lg:flex flex-col items-center gap-3 text-[#F2EDE3]/20">
        <div className="w-px h-14 bg-gradient-to-b from-[#C9A030]/50 to-transparent" />
        <span className="text-[9px] tracking-[0.4em] uppercase font-light">Scroll</span>
      </div>
    </section>
  );
}
